import flagsmith from 'flagsmith';

import Rollbar from 'src/analytics/rollbar';
import { getOptimizelyClient } from '../sdk';
import { handleExperimentTracking } from './track';
import { OptimizelyFlagResult, OptimizelyKey } from './types';

export const getOptimizelyFlag = async (flag: OptimizelyKey): Promise<OptimizelyFlagResult> => {
  const optimizely = getOptimizelyClient();

  if (!optimizely) {
    return {
      enabled: false,
      variationKey: '',
      variables: {}
    };
  }

  await optimizely.onReady();
  const decision = optimizely.decide(flag);

  handleExperimentTracking(flag, decision);

  return {
    enabled: decision.enabled,
    variationKey: decision.variationKey || '',
    variables: decision.variables || {}
  };
};

type FlagData = {
  enabled: boolean;
  value?: string | number | boolean | null;
};

export const getAllFlags = () => {
  try {
    const optimizely = getOptimizelyClient();

    const flagsmithFlags = flagsmith.getAllFlags() || {};
    const optimizelyFlags = optimizely?.decideAll() || {};

    const flagsmithFlagsFormatted = Object.entries(flagsmithFlags).reduce<Record<string, FlagData>>(
      (acc, [key, value]) => {
        acc[key] = {
          enabled: value.enabled,
          value: value.value
        };
        return acc;
      },
      Object.create(null)
    );

    const optimizelyFlagsFormatted = Object.entries(optimizelyFlags).reduce<
      Record<string, FlagData>
    >((acc, [key, value]) => {
      acc[key] = {
        enabled: value.enabled
      };
      return acc;
    }, Object.create(null));

    return {
      ...optimizelyFlagsFormatted,
      ...flagsmithFlagsFormatted
    };
  } catch (error) {
    Rollbar.trackError('Failed to get all flags', error as Error);
    return {
      default: {
        enabled: false
      }
    };
  }
};
